import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PageAlcohol() {
  return <Page pageNumber={36} variant="light" data-id="element-807">
      <div className="flex flex-col h-full" data-id="element-808">
        {/* Hero Image */}
        <div className="h-[200px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-809">
          <img src="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1000&q=80" alt="Elegant drink" className="w-full h-full object-cover" data-id="element-810" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-811" />
        </div>

        <div className="mb-8" data-id="element-812">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-813">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-814">
            Navigating <span className="text-tealslate" data-id="element-815">Alcohol</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-816" />
        </div>

        <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-817">
          <div className="space-y-4 text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-818">
            <p data-id="element-819">
              GLP-1 medications fundamentally change how your body processes
              alcohol. Many people find they lose their desire to drink
              entirely. This is because the medication dampens the dopamine
              reward pathway in the brain.
            </p>
            <p data-id="element-820">
              Reduced tolerance is real and well-documented. Because the
              medication slows digestion, alcohol may sit in your stomach
              longer, changing how and when it absorbs.
            </p>
          </div>
          <div className="space-y-4 text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-821">
            <p data-id="element-822">
              Alcohol provides empty calories that compete with your
              already-reduced intake. When you can only eat 1,000 to 1,500
              calories a day, every calorie matters. Alcohol takes the place of
              nutrients your body desperately needs.
            </p>
            <p data-id="element-823">
              Additionally, alcohol impairs sleep quality, which compounds other
              side effects and undermines recovery.
            </p>
          </div>
        </div>

        <div className="mb-8 pl-4" data-id="element-824">
          <PullQuote text="Your tolerance is not what it used to be. Respect that." variant="light" data-id="element-825" />
        </div>

        <div className="mt-auto bg-[#EAEAE4] border border-[#D8D8D0] p-6 w-full" data-id="element-826">
          <h3 className="font-serif text-xl text-[#1F1F1F] mb-4" data-id="element-827">
            Practical Guidance
          </h3>
          <ul className="grid grid-cols-2 gap-x-8 gap-y-4 text-xs text-[#7A7A70] leading-[1.6]" data-id="element-828">
            <li className="flex gap-3" data-id="element-829">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-830">•</span>
              <span data-id="element-831">
                If you choose to drink, reduce your quantity significantly.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-832">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-833">•</span>
              <span data-id="element-834">Eat a protein-rich meal before drinking.</span>
            </li>
            <li className="flex gap-3" data-id="element-835">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-836">•</span>
              <span data-id="element-837">
                Stay hydrated. Drink a full glass of water for every alcoholic
                drink.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-838">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-839">•</span>
              <span data-id="element-840">Be acutely aware of your new limits.</span>
            </li>
          </ul>
        </div>
      </div>
    </Page>;
}